module.exports = __webpack_public_path__ + "static/media/onoiwa-nav-r2.8b7bdcea.png";